// Service layer for patient profiles. Reads `shouldUseMocks()` and dispatches to
// either the mock module or the real /api/secure/me/profiles* API.
//
// Backend reference: in.aumhum.aumhum.patient.controller.MePatientProfileController
// (javaserver). Wire shapes match — see PatientProfileResponse.java.

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/profilesApi'
import { patientGet, patientPost, patientPatch, patientDelete } from './patientApi'

const BASE = '/api/secure/me/profiles'

// Profiles endpoints don't take patientId query param — see backend
// PatientContextInterceptor.PROFILE_AGNOSTIC_SUFFIXES. Listing/creating happens
// before a profile is selected; per-id endpoints are scoped via the path itself
// and re-checked against the user's links by the service layer.
const NO_CONTEXT = { requirePatientContext: false }

function unwrap(res) {
  return res?.data
}

export async function listMyProfiles() {
  if (shouldUseMocks()) return mock.listProfiles()
  const res = await patientGet(BASE, NO_CONTEXT)
  return unwrap(res) || []
}

export async function getMyProfile(id) {
  if (shouldUseMocks()) return mock.getProfile(id)
  const res = await patientGet(`${BASE}/${encodeURIComponent(id)}`, NO_CONTEXT)
  return unwrap(res)
}

export async function createMyProfile(input) {
  if (shouldUseMocks()) return mock.createProfile(input)
  const res = await patientPost(BASE, input, NO_CONTEXT)
  return unwrap(res)
}

export async function updateMyProfile(id, patch) {
  if (shouldUseMocks()) return mock.updateProfile(id, patch)
  const res = await patientPatch(`${BASE}/${encodeURIComponent(id)}`, patch, NO_CONTEXT)
  return unwrap(res)
}

export async function archiveMyProfile(id) {
  if (shouldUseMocks()) return mock.archiveProfile(id)
  await patientPost(`${BASE}/${encodeURIComponent(id)}/archive`, null, NO_CONTEXT)
  return null
}
